import { render, staticRenderFns } from "./done.vue?vue&type=template&id=fc995e9a&scoped=true"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"
import style0 from "./done.vue?vue&type=style&index=0&id=fc995e9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc995e9a",
  null
  
)

export default component.exports